module.exports = {
    delivery: {
        canLeaveUnattendedPreferenceHintText: 'If you might not be home during your delivery window but still wish to receive your delivery at that time, you can choose to have your items left unattended',
        canLeaveUnattendedPreferenceText: 'Leave items unattended',
        deliveryInstructionLabel: 'Do you have instructions for the driver?',
        deliveryInstructionPlaceholder: 'Eg. put items in ice cooler',
        deliverySubmitError: 'All delivery information needs to be set before you confirm delivery.',
        deliveryWindowReloadingMessage: 'Refreshing products and pricing for your new delivery time and location.',
        deliveryWindowReservedMessage: 'Exclusive access',
        frozenDeliveryWarning: `
                <h4 style="margin-bottom: 8px;">Just a heads up</h4>
                <p style="margin: 0;font-weight: normal;">Your order includes chilled items that may spoil if left unattended.</p>
            `,
        mobileErrorMessage: 'It seems like the mobile number you\'ve entered isn\'t a valid number',
        mobileErrorTitle: 'Please check your mobile number',
        mobileHintText: '*We\'ll call this number if there are any delays or issues with the delivery of your order',
        pickupInstructionLabel: 'Instructions for my Pick Up store',
        pickupInstructionPlaceholder: 'Eg. My partner will pick up the order',
        restrictionWarningDeliverySignature: `
                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>
                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign for this delivery.</p>
            `,
        restrictionWarningDeliverySignatureAndPhotoId: `
                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>
                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign and have their ID scanned for this delivery.</p>
            `,
        restrictionWarningPickupSignature: `
                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>
                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign.</p>
            `,
        restrictionWarningPickupSignatureAndPhotoId: `
                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>
                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign and have their ID scanned.</p>
            `,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/delivery.js